var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0534 18.0668C23.4934 18.6135 23.1734 19.4002 23.2534 20.2402C23.3734 21.6802 24.6934 22.7335 26.1334 22.7335H28.6667V24.3202C28.6667 27.0802 26.4134 29.3335 23.6534 29.3335H8.34671C5.58671 29.3335 3.33337 27.0802 3.33337 24.3202V15.3468C3.33337 12.5868 5.58671 10.3335 8.34671 10.3335H23.6534C26.4134 10.3335 28.6667 12.5868 28.6667 15.3468V17.2668H25.9734C25.2267 17.2668 24.5467 17.5601 24.0534 18.0668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 16.5467V10.4535C3.33337 8.86681 4.30671 7.45341 5.78671 6.89341L16.3734 2.89341C18.0267 2.26675 19.8 3.49345 19.8 5.26679V10.3334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0785 18.6268V21.3735C30.0785 22.1069 29.4918 22.7068 28.7451 22.7335H26.1318C24.6918 22.7335 23.3718 21.6802 23.2518 20.2402C23.1718 19.4002 23.4918 18.6135 24.0518 18.0668C24.5451 17.5601 25.2251 17.2668 25.9718 17.2668H28.7451C29.4918 17.2935 30.0785 17.8935 30.0785 18.6268Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 16H18.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.2468bcebb1383a16baae984141445231.svg";
export { ForwardRef as ReactComponent };